import { c as _c } from "react/compiler-runtime";
import { useCallback, useState } from 'react';
import { Popover, type PopoverState } from 'react-tiny-popover';
import { SocialMediaPopover } from '#components/SocialMediaPopover';
import { useEnvironment } from '#cutils/context/EnvironmentContext';
import { COMMENT_BUTTON_ID } from '#cutils/hooks/useComments';
import { createShareUrl } from '#cutils/shareurls/createShareUrl';
import { useCommentsCount } from './CommentsCount/use-comments-count';
import styles from './SocialMediaSharer.module.scss';
import { Count } from './base/Count/Count';
import { IconSystemButton } from './base/IconButton/IconSystemButton';
import { IconSystemLink } from './base/IconButton/IconSystemLink';
const MOBILE_REGEX = /iPad|iPhone|iPod|android/i;
function isUAMobile(userAgent: string) {
  return MOBILE_REGEX.test(userAgent);
}
type Props = {
  direction: 'horizontal' | 'vertical';
  headline?: string | null;
  url: string;
  className?: string;
  commentId?: string;
};
export function SocialMediaSharer(t0) {
  const $ = _c(30);
  const {
    className: t1,
    direction,
    headline,
    url,
    commentId
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const environment = useEnvironment();
  const [popOverVisible, setPopOverVisible] = useState(false);
  const [isMobile] = useState(_temp);
  const commentCount = useCommentsCount(commentId);
  const isHorizontal = direction === "horizontal";
  const t2 = headline ? headline : "";
  let t3;
  if ($[0] !== t2 || $[1] !== url) {
    t3 = createShareUrl("email", t2, "E-Mail", url);
    $[0] = t2;
    $[1] = url;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const mailShareUrl = t3;
  let t4;
  if ($[3] !== headline || $[4] !== isMobile || $[5] !== popOverVisible || $[6] !== url) {
    t4 = async () => {
      let sharingUrl;
      ;
      try {
        const urlObject = new URL(url);
        urlObject.searchParams.set("UTM_Name", "Web-Share");
        urlObject.searchParams.set("UTM_Source", "Link");
        urlObject.searchParams.set("UTM_Medium", "Link");
        sharingUrl = urlObject.toString();
      } catch (t5) {
        sharingUrl = url;
      }
      const shareData = {
        text: headline ? `${headline} | via BR24` : "Via BR24",
        url: sharingUrl
      };
      if (isMobile && navigator.canShare?.(shareData)) {
        ;
        try {
          await navigator.share(shareData);
        } catch (t6) {
          const e_0 = t6;
        }
      } else {
        setPopOverVisible(!popOverVisible);
      }
    };
    $[3] = headline;
    $[4] = isMobile;
    $[5] = popOverVisible;
    $[6] = url;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const togglePopOver = t4;
  const t5 = `${styles.wrapper} ${className ? className : ""} ${isHorizontal ? styles.isWrapperHorizontal : ""}`;
  let t6;
  if ($[8] !== commentCount || $[9] !== commentId || $[10] !== environment) {
    t6 = typeof commentId === "string" && !environment.flags.IS_COMMENTS_HIDDEN && <IconSystemLink type="secondary" icon="comment" variant="filled" title="Kommentare anzeigen" className={styles.commentButton} href={{
      hash: COMMENT_BUTTON_ID
    }}>{commentCount !== undefined && commentCount !== 0 ? <Count className={styles.commentsCount} count={commentCount} aria-label="Anzahl Kommentare" /> : null}</IconSystemLink>;
    $[8] = commentCount;
    $[9] = commentId;
    $[10] = environment;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== mailShareUrl) {
    t7 = <IconSystemLink target="_self" href={mailShareUrl} type="secondary" icon="mail" variant="filled" title="Per Mail teilen" />;
    $[12] = mailShareUrl;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = ["bottom", "right"];
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => setPopOverVisible(false);
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== headline || $[17] !== url) {
    t10 = t11 => {
      const {
        position,
        nudgedLeft,
        nudgedTop,
        popoverRect
      } = t11;
      const arrowPositionLeft = popoverRect.width / 2 - nudgedLeft;
      const arrowPositionTop = popoverRect.height / 2 - nudgedTop;
      return <SocialMediaPopover headline={headline} url={url} onClose={() => setPopOverVisible(false)} position={position} arrowPositionLeft={arrowPositionLeft} arrowPositionTop={arrowPositionTop} />;
    };
    $[16] = headline;
    $[17] = url;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== togglePopOver) {
    t11 = <IconSystemButton type="secondary" icon="share" variant="filled" title="Teilen" onClick={togglePopOver} />;
    $[19] = togglePopOver;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== popOverVisible || $[22] !== t10 || $[23] !== t11) {
    t12 = <Popover isOpen={popOverVisible} positions={t8} boundaryInset={20} reposition={true} containerClassName={styles.popoverContainer} onClickOutside={t9} content={t10}>{t11}</Popover>;
    $[21] = popOverVisible;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12 || $[26] !== t5 || $[27] !== t6 || $[28] !== t7) {
    t13 = <div className={t5}>{t6}{t7}{t12}</div>;
    $[25] = t12;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
}
function _temp() {
  return typeof window !== "undefined" && isUAMobile(navigator.userAgent);
}